import { render } from "./CommunicationDataScreen.vue?vue&type=template&id=0edc636c&scoped=true&lang=html"
import script from "./CommunicationDataScreen.vue?vue&type=script&lang=js"
export * from "./CommunicationDataScreen.vue?vue&type=script&lang=js"

import "./CommunicationDataScreen.vue?vue&type=style&index=0&id=0edc636c&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/progressive_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edc636c"]])

export default __exports__